import * as React from 'react';

import type {ReportRowData, ComparedActivityReportSummary} from 'nutshell-core/types';

import {Avatar} from 'shells/avatar/avatar';
import {getInitials} from 'shells/utils/get-initials';

import styles from './activity-report-summary-table.module.css';

type ActivityTableNameCellProps = {
    data: ComparedActivityReportSummary<Array<ReportRowData>>;
    rowIndex: number;
    style: any;
};

export const ActivityTableNameCell = ({data, rowIndex, style}: ActivityTableNameCellProps) => {
    const rowData = data.currentPeriod[rowIndex - 1] || {title: ''};
    const styleName = rowIndex % 2 === 0 ? styles['user-striped'] : styles.user;
    const initials = getInitials(rowData.title);

    return (
        <div style={style} className={styleName}>
            <div className={styles.avatar}>
                {/* @ts-expect-error */}
                <Avatar avatarUrl={rowData.avatarUrl} initials={initials} size={34} type='users' />
            </div>
            <div className={styles.username}>{rowData.title}</div>
        </div>
    );
};
